module.exports = __webpack_public_path__ + "img/facebook-square.2362db2e.svg";